export const checkIfUserIsAuthenticated = (expirationDate: string) =>
  new Date() <= new Date(expirationDate);
